export default __webpack_public_path__ + "static/media/default.307b0b25.png";